import Reports from './reports';
import API from './api';

const api = new API();

const URL_FRAUD_PROTECTED = '/api/fraud_protected_report';

let instance = null;

class FraudProtected {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    runQuery(params, options) {
        return new Promise((resolve, reject) => {
            api.getJson(URL_FRAUD_PROTECTED, {
                method: 'POST',
                credentials: 'include',
                body: {
                    ...params,
                },
                cache: false,
                unique: true,
                ...options,
            })
                .then(response => {
                    if (response.status !== 0) {
                        reject(Reports.ERROR_RUN_QUERY);
                    }
                    resolve(response.value);
                })
                .catch(reject);
        });
    }
}

export default FraudProtected;
